import { useQuery } from '@tanstack/react-query'
import { OPS_SIGNED_URL_TTL_S, resolveStoredImageRef, type OpsSignedUrlAudience } from '@willie/supabase/storage'
import { useAuth } from '~/auth/AuthProvider'

// Re-sign before the link dies rather than after. Holding a cached URL for its full
// lifetime means the moment it goes stale it is also already expired, so an ops tab
// left open renders a broken image until it remounts.
const REFRESH_AT = 0.8

/**
 * Resolves a stored image reference — an ops storage path, a legacy public URL, or a
 * third-party URL — into something an `<img>` can load.
 */
export const useOpsSignedUrl = (stored: string | null | undefined, audience: OpsSignedUrlAudience = 'display') => {
  const { supabaseClient } = useAuth()
  const lifetimeMs = OPS_SIGNED_URL_TTL_S[audience] * 1000

  return useQuery({
    queryKey: ['ops-signed-url', audience, stored] as const,
    queryFn: () => resolveStoredImageRef(supabaseClient, stored, audience),
    enabled: !!stored,
    staleTime: lifetimeMs * REFRESH_AT,
    gcTime: lifetimeMs
  })
}
